import { Routes } from '@angular/router';
import { IndexComponent } from './components/index/index';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy';
import { UserAgreementComponent } from './components/user-agreement/user-agreement';
import { MapComponent } from './maps/maps';

export const routes: Routes = [
  { path: '', component: IndexComponent },
  { path: 'Politica-de-Privacidade', component: PrivacyPolicyComponent },
  { path: 'Acordo-de-Utilização', component: UserAgreementComponent },
  { path: '**', redirectTo: '' },
  { path: 'maps', component: MapComponent }
];